<template>
    <div class="open-bills-for-table-popover-content">
        <OpenBillsForTableList :tableId="tableId" @openBillSelected="onOpenBillSelectedEvent" />
    </div>
</template>

<script setup lang="ts">
    import type { OpenBillSelectedEventData } from "@/data/model/Bill";

    import OpenBillsForTableList from "@/operator/components/bill/OpenBillsForTableList.vue";

    // define props
    const props = defineProps<{
        tableId: string;
        onClose: () => void;
        onOpenBillSelected: (openBill: OpenBillSelectedEventData) => void;
    }>();

    const emit = defineEmits(["close", "openBillSelected"]);

    function onOpenBillSelectedEvent(openBill: OpenBillSelectedEventData) {
        emit("openBillSelected", openBill);
        props.onOpenBillSelected(openBill);

        close();
    }

    function close() {
        emit("close");
        props.onClose();
    }
</script>

<style lang="scss">
    .open-bills-for-table-popover-content {
        padding: 0 0 3.5em;
    }
</style>
